
export default class Request {

    static baseUrl
    static credentials = null
    static instance = null


    static init( credentials) {
        if (Request.credentials)
            console.warn('Request já inicializado.')

        Request.credentials = credentials

        Request.instance = new Request()
    }

    static getInstance() {

        if (!Request.instance)
            throw new Error('Request nao foi inicializado. Chamar metodo init().')

        return Request.instance
    }

    createGetRequest(reqUrl, params, headers, newApi, withCredentials) {
        return this._createRequest(reqUrl, 'GET', params, headers, newApi, withCredentials)
    }

    createPostRequest(reqUrl, params, headers, newApi, withCredentials) {
        return this._createRequest(reqUrl, 'POST', params, headers, newApi, withCredentials)
    }

    createUpdateRequest(reqUrl, params, headers, newApi, withCredentials) {
        return this._createRequest(reqUrl, 'PUT', params, headers, newApi, withCredentials)
    }

    createDeleteRequest(reqUrl, params, headers, newApi, withCredentials) {
        return this._createRequest(reqUrl, 'DELETE', params, headers, newApi, withCredentials)
    }

    _createRequest(reqUrl, method, params = {}, headers = {}, newApi = false, withCredentials = true) {

        let url = newApi ? reqUrl : reqUrl + '?'

        const _headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...headers
        }


        if (newApi)
            _headers.schema = Request.credentials.schema

        const fetchParams = {
            method: method,
            headers: _headers,
            body: JSON.stringify(params),
            mode: 'cors',
        }

        if (method === 'GET') {
            if (Object.keys(params).length > 0)
                url += (url.indexOf('?') === -1 ? '?' : '&') + this._queryParams(params)

            delete fetchParams.body
        }

        if (withCredentials) {

            //adiciona credentials no queryparams
            if (newApi) {
                fetchParams.headers[ 'Authorization' ] = `Bearer ${Request.credentials.token}`
            } else {
                const {token, username} = Request.credentials
                url += `&token=${'NTkzNjE2ZGUxNTMzMGMwZmIyZDU1ZTU1NDEwYmY5OTQ6Q0VOVFJBTF9ET19DTElFTlRFOjcxYjJINmJw'}&username=${username}`
            }
        }

        return fetch(url, fetchParams)
            .then((response) => {

                if (response.ok)
                    return response

                throw response
            })
            .then(r => r.json())
    }

    _queryParams(params) {
        return Object.keys(params)
            .map(k => {

                const value = params[k]
                const field = encodeURIComponent(k)


                if (Array.isArray(value))
                    return value.map((v) => field + '=' + encodeURIComponent(v)).join('&')

                return field + '=' + encodeURIComponent(params[k])
            })
            .filter((value) => !!value)
            .join('&')
    }
}



// WEBPACK FOOTER //
// ./src/helpers/request.js